import React from 'react';
import pencilIcon from '../../../../../../shared/assets/images/lotto-assistant/pencil-outlined.svg';
import classes from './BallsDisplay.module.scss';

const getBallClass = (num) => {
  const isEmpty = Number.isNaN(num.value);
  if (isEmpty) {
    return num.type === 'BONUS' ? classes.EmptyBonus : classes.EmptyNormal;
  }
  return num.type === 'BONUS' ? classes.Bonus : classes.Normal;
};

const BallsDisplay = ({
  numbers,
  size = 'medium',
  onEditClick,
  showEditButton = false,
  gap = 8,
}) => (
  <div className={classes.Container}>
    <div
      className={classes.BallsRow + ' ' + classes['Size_' + size]}
      style={{ gap }}
    >
      {numbers.map((num, i) => {
        const isEmpty = Number.isNaN(num.value);
        return (
          <div key={i} className={classes.Ball + ' ' + getBallClass(num)}>
            {!isEmpty && <span className={classes.BallText}>{num.value}</span>}
          </div>
        );
      })}
    </div>
    {showEditButton && onEditClick && (
      <button
        type="button"
        onClick={onEditClick}
        aria-label="Edit balls"
        className={classes.EditButton}
      >
        <img src={pencilIcon} alt="" width={20} height={20} className={classes.EditIcon} />
      </button>
    )}
  </div>
);

export default BallsDisplay;
